import styled from 'styled-components';
import { ColorHealth5, ColorNordicGrey4 } from 'autogen/design-tokens/tokens';
import type { BasketMessageShippingViewModel } from 'autogen/swagger/all';
import { Typography } from 'components/generic/typography';
import WithIcon from 'components/hoc/withIcon/WithIcon';
import Icon from 'components/Icon';
import format from 'helpers/translations';
import BasketMessageContainer from '../shared/styles';

const StyledBasketMessageContainer = styled(BasketMessageContainer)<{ $achievement?: boolean }>`
    background-color: ${({ $achievement }) => ($achievement ? ColorHealth5 : ColorNordicGrey4)};
`;

export default function ShippingMessage({ model: { text, intro } }: { model: BasketMessageShippingViewModel }) {
    if (intro) {
        return (
            <StyledBasketMessageContainer $achievement>
                <WithIcon icon={<Icon type="Checkmark" size={16} />}>
                    <Typography.Body as="span" size="S">
                        {format(intro)} {format(text)}
                    </Typography.Body>
                </WithIcon>
            </StyledBasketMessageContainer>
        );
    }

    return (
        <StyledBasketMessageContainer>
            <Typography.Body as="span" size="S">
                {format(text)}
            </Typography.Body>
        </StyledBasketMessageContainer>
    );
}
